import { graphql } from '@newfront-insurance/graphql-frontend';

export const GET_ACCOUNT = graphql(`
  query GetAccount($uuid: String!) {
    getAccount(uuid: $uuid) {
      uuid
      name
      programType
      globalClientId
    }
  }
`);

export const COMPLETE_NOVA_MICROSOFT_GRAPH_AUTHORIZATION = graphql(`
  mutation CompleteNovaMicrosoftGraphAuthorization($command: CompleteNovaMicrosoftGraphAuthorizationInput!) {
    completeNovaMicrosoftGraphAuthorization(command: $command) {
      connectionUuid
      status
    }
  }
`);
